import MsButton from './src/button.vue'

export default MsButton
